const template = `
<div class="dialog-wrapper">
	<div class="dialog export">

		<h1 class="dialog-export-title dialog-title"></h1>
		<hr>
		<div class="has-warnings warnings"></div>
		<hr>
		<p class="popup-warning"></p>
		<hr>

		<ul class="button-list fgrid fgrid--1of2 fgrid--justifyCenter">
			<li id="api" class="fgrid-cell positive">
				<form target="_popup" enctype="multipart/form-data" method="post" action="https://www.atg.se/services/v1/user/bets/upload/transferFileBet">
					<input id="xmlinput" name="fileBetXml" type="hidden" value="">
					<input id="submit" class="positive dialog-export-button" type="submit" style="background-color: transparent; color:transparent; border:none; float:left; padding: 0; height:0;">
					<label for="submit" class="inline-block" style="cursor:pointer;">
						<a class="positive dialog-export-button" style="pointer-events:none;">
							<span class="sprite dialog-confirm"></span>
							<span class="label"></span>
						</a>
					</label>
				</form>
			</li>
			<li id="tillsammans" class="fgrid-cell positive">
				<form target="_popup" method="post" action="https://tillsammans.atg.se/laddauppfil">
					<input id="xmlinput_ts" name="fileBetXml" type="hidden" value="">
					<input id="submit_ts" class="positive dialog-export-button" type="submit" style="background-color: transparent; color:transparent; border:none; float:left; padding: 0; height:0;">
					<label for="submit_ts" class="inline-block" style="cursor:pointer;">
						<a class="positive dialog-export-button" style="pointer-events:none;cursor:pointer;">
							<span class="sprite dialog-confirm"></span>
							<span class="label"></span>
						</a>
					</label>
				</form>
			</li>
			<li id="download" class="fgrid-cell positive">
				<a data-value="2" class="active positive dialog-export-button"><span class="sprite dialog-confirm"></span><span class="label"></span></a>
			</li>
			<li id="cancel" class="fgrid-cell negative"><a data-value="false" class="active negative dialog-export-button"><span class="sprite dialog-cancel"></span><span class="label"></span></a></li>
		</ul>

		<ul class="button-list fgrid fgrid--full">
		</ul>


		<table id="under-buttons">
			<tr class="divider">
				<td colspan="4"><hr></td>
			</tr>
			<tr>
				<td colspan="4" class="text"></td>
			</tr>
		</table>


	</div>
</div>
`;

export default template;
